export function startsWithWhiteSpace(str) {
  return str.charAt(0) === " ";
}

export function startsWithNumber(str) {
  return /^\d/.test(str);
}

export function containsSpecialCharacters(str) {
  // Define a regular expression pattern that matches special characters
  const specialCharsRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\|'"`=\/\-]/;

  // Test if the string contains any special characters
  return specialCharsRegex.test(str);
}

export function onlyAlphabeticalCharacters(str) {
  const alphabeticalCharacters = /^[A-Za-z]+$/;
  return alphabeticalCharacters.test(str);
}

export function validateEmail(str) {
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
  return emailRegex.test(str);
}

export function calculateGridElements() {
  const pageWidth = window.innerWidth;
  if (pageWidth < 480) {
    return 6;
  } else if (pageWidth < 1100) {
    return 8;
  } else {
    return 9;
  }
}
